import { render, staticRenderFns } from "./ExportPdfIelts.vue?vue&type=template&id=b360dcac&"
import script from "./ExportPdfIelts.vue?vue&type=script&lang=js&"
export * from "./ExportPdfIelts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports